module.exports = __webpack_public_path__ + "img/DefaultParkImage_grayscale.63c79ac5.png";